import React, { PureComponent } from 'react'
import { modal } from './styles'

const ModalTitle = props => {
  return (
    <div>
      <h1>{props.title} </h1>
      <h4>{props.subtitle} </h4>
      <style jsx>{modal}</style>
    </div>
  )
}

export default ModalTitle
